<script>

export default {
  props: ["component", "handler", "title", "description"],
  components: {},
  methods: {
  },
  data: function () {
    return {
    };
  },
  computed: {
  }
};
</script>

<template>
  <f-textfield :input.sync="component.value" @blur="handler.action(component, 'set', [component.value])">
    <template v-slot:label>{{title}}</template>
    <template v-slot:helper>{{description}}</template>
  </f-textfield>
</template> 

<style lang="scss">
</style>